interface Token {
    pattern: RegExp
    transform?: (value: string) => string
}

const tokens: { [key: string]: Token } = {
    '#': { pattern: /\d/ },
    S: { pattern: /[a-z]/i },
    A: { pattern: /[0-9a-z]/i },
    U: { pattern: /[a-z]/i, transform: (v: string) => v.toLocaleUpperCase() },
    L: { pattern: /[a-z]/i, transform: (v: string) => v.toLocaleLowerCase() },
}

export const numberInputs: string[] = [
    'phone',
    'date',
    'time',
    'number',
    'snils',
    'inn',
    'passport',
    'payment',
    'code',
    'percent',
    'year',
    'month',
    'cardDate',
    'cvv',
    'card',
]

export const masks: { [key: string]: string } = {
    phone: '+7 (###) ###-##-##',
    date: '##/##/####',
    time: '##:##',
    number: '##########',
    snils: '###-###-### ##',
    inn: '############',
    passport: '#### ######',
    payment: '#### #### #### ####',
    percent: '####',
    year: '####',
    pin: '####',
    months: '####',
    cardDate: '## / ##',
    cvv: '###',
    card: '#### #### #### ####',
}

export function removeMask(value: string): string {
    // Убираем все символы, кроме цифр и +
    let sanitized = value.replace(/[^+\d]/g, '')

    // Убираем +, если он не первый
    if (sanitized.indexOf('+') > 0) {
        sanitized = sanitized.replace(/\+/g, '')
    }

    return sanitized
}

export function addMask(value: string, mask: string, keepMasked: boolean = true): string {
    let iMask = 0
    let iValue = 0
    let output = ''
    while (iMask < mask.length && iValue < value.length) {
        let cMask = mask[iMask] || ''
        const masker = tokens[cMask]
        const cValue = value[iValue]
        if (masker) {
            if (masker.pattern.test(cValue as string)) {
                output += masker.transform ? masker.transform(cValue as string) : cValue
                iMask++
            }
            iValue++
        } else {
            if (masker) {
                iMask++
                cMask = mask[iMask] || ''
            }
            if (keepMasked) {
                output += cMask
            }
            if (cValue === cMask) {
                iValue++
            }
            iMask++
        }
    }

    while (iMask < mask.length) {
        const cMask = mask[iMask]
        if (tokens[cMask as string]) {
            break
        }
        iMask++
    }

    return output
}

export function setCursor(el: HTMLInputElement, position: number): void {
    if (el === document.activeElement) {
        el.setSelectionRange(position, position)
        setTimeout(() => {
            el.setSelectionRange(position, position)
        }, 0)
    }
}
